<template>
    <MainContentSearchable title="Listado de precios" id="categorias" v-model="filters" :meta="loading ? {} : categorias.meta" @updated="getCategorias">
        <template v-slot:header>
            <div class="ml-auto">
                <router-link :to="{ name: 'back.bases.categorias.crear', params: { lista_id: lista_id } }" class="btn btn-primary mb-3" target="blank">Nueva categoría</router-link>
                <router-link :to="{ name: 'back.frecuencias' }" class="btn btn-primary mb-3 ml-2" target="blank">Frecuencias pago a plazos</router-link>
            </div>
        </template>
        <template v-slot:content>
            <div>
                <div :class="['table', { 'expanded': categorias.data.length <= 3 }]">
                    <b-table hover :items="categorias.data" :fields="fields" id="categorias-table">
                        <template #cell(precio)="{ item }">
                            {{ item.precio | formatear_precio }}
                        </template>
                        <template #cell(indumentarias)="{ item }">
                            <b-card>
                                <b-card-text v-if="item.indumentariasSelect.length > 0">
                                    {{ item.indumentariasSelect.length > 1 ? item.indumentariasSelect.map(i => i.nombre).join(', ') : item.indumentariasSelect.map(i => i.nombre).join('') }}
                                </b-card-text>
                                <b-card-text v-else>
                                    No tiene indumentarias
                                </b-card-text>
                            </b-card>
                        </template>
                        <template #cell(opciones)="{ item }">
                            <OpcionesDropdownTableComponent 
                                :lastIndex="categorias.data.length > 3 && index >= categorias.data.length - 3"
                                v-bind:options="[
                                    { type: 'action', action:() => showModal('editar-' + item.id), label: 'Editar'},
                                    { type: 'action', action:() => showModal('borrar-' + item.id), label: 'Borrar'},
                                    ... manager.activar_compra_por_invitacion_bases ? [{ to: { name: 'back.bases.categorias.codigos_invitacion', params: { lista_id: lista_id, categoria_id: item.id } }, label: 'Códigos invitación'}] : [],
                                    { to: { name: 'back.bases.categorias.resumen', params: { lista_id: lista_id, categoria_id: item.id } }, label: 'Resumen'},
                                ]"
                            />
                            <EditarCategoria :categoria="item" v-on:close="closeModal" @actualizar="getCategorias()"/>
                            <BorrarCategoria :categoria="item" v-on:close="closeModal"/>
                        </template>
                        <template #cell(activar_pago_plazos)="{ item }">
                            <span v-if="item.activar_pago_plazos" class="mr-2"><i class="text-green fas fa-check-circle"></i></span>
                            <span v-else class="mr-2"><i class="text-danger fas fa-times-circle"></i></span>
                        </template>
                        <template #cell(taquilla)="{ item }">
                            <span v-if="item.taquilla" class="mr-2"><i class="text-green fas fa-check-circle"></i></span>
                            <span v-else class="mr-2"><i class="text-danger fas fa-times-circle"></i></span>
                        </template>
                        <template #cell(online)="{ item }">
                            <span v-if="item.online" class="mr-2"><i class="text-green fas fa-check-circle"></i></span>
                            <span v-else class="mr-2"><i class="text-danger fas fa-times-circle"></i></span>
                        </template>
                        <template #cell(representante)="{ item }">
                            <p>{{ item.representante ? item.representante.name : '' }}</p>
                        </template>
                    </b-table>
                </div>
            </div>
        </template>
    </MainContentSearchable>
</template>

<script>
    import EditarCategoria from './modals/EditarCategoria';
    import BorrarCategoria from './modals/BorrarCategoria';
    import MainContentSearchable from '@/components/backend/components/MainContentSearchable';
    import OpcionesDropdownTableComponent from "@/components/backend/components/OpcionesDropdownTableComponent";

    export default {
        data() {
            return {
                categorias: {},
                loading: false,
                filters: {
                    per_page: 10,
                    page: 1,
                    search: '',
                    tipo: null
                },
                fields: [
                    { key: "id", label: "ID", class: 'text-center'},
                    { key: "name", label: "Nombre", class: 'text-center' },
                    { key: "precio", label: "Precio", class: 'text-center' },
                    { key: "indumentarias", label: "Indumentarias", class: 'text-center w-25' },
                    { key: "observacion_indumentarias", label: "Observación Indumentarias", class: 'text-center w-25' },
                    { key: "activar_pago_plazos", label: "Pago a plazos", class: 'text-center' },
                    { key: "taquilla", label: "Taquilla", class: 'text-center' },
                    { key: "online", label: "Online", class: 'text-center' },
                    { key: "representante", label: "Representante", class: 'text-center' },
                    { key: "opciones", label: "Acciones", class: 'text-center' }
                ],
            }
        },
        created() {
            this.getCategorias();
        },
        computed: {
            manager() {
                return this.$store.getters.getFooter;
            },
            lista_id() {
                return this.$route.params.lista_id;
            }
        },
        methods: {
            getCategorias() {
                this.loading = true;

                let params = {
                    lista_id: this.lista_id,
                    filters: this.filters
                };
                this.$store.dispatch(this.config.getVuexAlias('back.bases.categorias.index'), params).then(res => {
                    this.categorias = res.data;
                }).finally(() => this.loading = false);
            },
            borrar(id) {
                this.loading = true;

                var params = {
                    lista_id: this.lista_id,
                    categoria_id: id,
                    filters : {}
                };

                this.$store.dispatch(this.config.getVuexAlias('back.bases.categorias.borrar'), params).then(res => {
                    this.$toast.success(res.data.message, {});
                    this.getCategorias();
                }).finally(() => this.loading = false);
            },
            setPage(page) {
                this.filters.page = page;
                this.getCategorias();
            },
            showModal(modal) {
                this.$modal.show(modal);
            },
            closeModal(modal) {
                this.$modal.hide(modal);
                this.getCategorias();
            },
        },
        components: {
            MainContentSearchable, OpcionesDropdownTableComponent, BorrarCategoria, EditarCategoria
        }
    }
</script>
<style scoped>
.table {
    overflow: auto;
}

.table.expanded {
    padding-bottom: 150px !important;
}
</style>